import React from 'react';
import cx from 'classnames';
import Tooltip from 'rc-tooltip';

import Icon from '../../../../../../../common/general/Icon';
import { UNEXPECTED } from '../../../../../../../constants/encounter';
import { EncounterModificationMenu } from '../../../EncounterDescNew/EncounterDetailsHeader/EncounterModificationMenu';
import {
  isAbleToEditEncounter,
  isCloseEncounterMenuAvailable,
  isEncounterStartedAndIncomplete
} from '../../../EncounterDescNew/encounterDetailsService';

import './DetailsSidebarHeader.scss';

export default function DetailsSidebarHeader({
  encounter,
  currentPatient,
  encounterDetailsList,
  encounterType,
  currentEncounterIsClosable,
  encounterStatus,
  cancelEncounter,
  reopenEncounter,
  markItemGroupsNotPerformedAndNotAsked,
  setSearchString
}) {
  return (
    <div className="details-sidebar-header left-header">
      <div className="px-3 mt-4">
        <h4>
          <span className="mr-2">{encounter.encounterName}</span>
          <Tooltip
            destroyTooltipOnHide={false}
            trigger={encounterStatus === 'Canceled' ? ['hover'] : []}
            placement="right"
            overlayClassName="eds-rc-tooltip"
            mouseEnterDelay={0}
            mouseLeaveDelay={0}
            overlay={<span>{encounter.statusChangeReason}</span>}
          >
            <div className={cx('status-label', encounterStatus === 'Canceled' ? 'canceled' : '')}>
              {encounterStatus ? encounterStatus : <div className="dots-loader"></div>}
            </div>
          </Tooltip>
        </h4>
        {isAbleToEditEncounter(encounter?.nonProtocol, currentPatient?.studySiteStatus) &&
          !!encounter &&
          encounterStatus && (
            <EncounterModificationMenu
              cancelEncounterAvailable={encounterStatus !== 'Canceled'}
              cancelEncounter={cancelEncounter}
              reopenEncounter={reopenEncounter}
              isUnexpectedEncounter={encounterType === UNEXPECTED}
              notPerformAllItemsAvailable={isEncounterStartedAndIncomplete(encounterDetailsList)}
              showCloseEncounterOption={
                currentEncounterIsClosable &&
                isCloseEncounterMenuAvailable(encounter?.nonProtocol, currentPatient.sitePatientStatus)
              }
              markItemGroupsNotPerformedAndNotAsked={markItemGroupsNotPerformedAndNotAsked}
            />
          )}
      </div>
      <div className={'m-3 search'}>
        <input onChange={e => setSearchString(e.target.value)} />
        <Icon>search</Icon>
      </div>
    </div>
  );
}
